$(document).ready(function(){
    var slider = $('.create-your-plan-slider');

    var selectedItems = {}

    slider.on('init', function(event, slick){
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            success: function() {
                $('.item_count').addClass('hidden-count')
            }
        });
    });

    // Init the Slider on Page Load
    slider.slick({
        dots: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        swipe: false,
        swipeToSlide: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        onAfterChange: function () {
            $('.slide-slide').slickSetOption(null, null, true);
        }
    });
    
    Shopify.queue = [];

    // Adding to Cart 
    // Called once to start, then again after each item is added.
    // window.cekProcessing (page.create-your-plan.liquid) shows the "Putting your meals together" screen.
    Shopify.moveAlong = function () {
        if (window.cekProcessing) {
            window.cekProcessing.progress(Shopify.queue);
        }
        slider.slick('slickGoTo', 4);
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.tabbable').offset().top
        }, 300);
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties,request.sellingPlanId, Shopify.moveAlong);
        } else if (window.cekProcessing) {
            window.cekProcessing.finish();
            setTimeout(function () {
                document.location.href = '/cart';
            }, 1000); // long enough to see "All done!"
        } else {
            document.location.href = '/cart';
        }
    };

    Shopify.addItem = function (id, qty, properties,sellingPlanId, callback) {
        var params = {
            quantity: qty,
            id: id,
            properties: {
                'Custom_Bundle': "1"
            }
        };
        if(sellingPlanId != "" && sellingPlanId > 1)
        {
          params['selling_plan'] = sellingPlanId;
        }
        if (properties != false) {
            // params.properties = properties;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,

            success: function () {
                if (typeof callback === 'function') {
                    callback();
                }
            },
            error: function (data) {
                console.log(data)
                if (window.cekProcessing) {
                    window.cekProcessing.fail();
                }
            }
        });
    }

    function push_to_queue(variantID, quantity, properties , sellingPlanId) {
        Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            sellingPlanId: sellingPlanId,
            properties: properties
        });
    }

    function storeSelected(selectedClass, thisObj, dataType) {
        var selectedAttr = thisObj.data(dataType);
        $(selectedClass).text(selectedAttr);
    }

    function allowNext() {
        $('#funnel-next').removeClass('disabled');
    }

    function getSelected(selectedClass) {
        return $(selectedClass).text();
    }

    function getMeals(callback) {
        var selectedType = getSelected('#selectedGoal');
        var mealAmount = $('.one-off-meals').length;
        var i = 0;
        
        $('.one-off-meals').each(function () {
            i++;
            balancedId = parseFloat($(this).attr('data-variant-id-balanced'));
            slimId = parseFloat($(this).attr('data-variant-id-slim'));
            singleId = parseFloat($(this).attr('data-variant-id-single'));
          
            // if (selectedType == 'slim') {
            //     var thisProductID = parseFloat($(this).attr('data-variant-id-slim'));
            // } else {
            //     var thisProductID = parseFloat($(this).attr('data-variant-id-balanced'));
            // }
            var slimInputValue = parseFloat($(this).find('.slim-quantity-box').val());
            var balancedInputValue = parseFloat($(this).find('.balanced-quantity-box').val());
            var singleInputValue = parseFloat($(this).find('.single-quantity-box').val());

            if (singleInputValue > 0) {
                push_to_queue(singleId, singleInputValue);
            }
            if (slimInputValue > 0) {
                push_to_queue(slimId, slimInputValue);
            }
            if (balancedInputValue > 0) {
                push_to_queue(balancedId, balancedInputValue);
            }
            if(i == mealAmount) {
                callback();
            }
        })
    };


    function alterBarValues(modifer) {
        $('.brown-bar-progress').css('transform', 'translateY(0px)');
        // if (modifer == "plus") {
        //     $('.meals-chosen span').text(parseInt($('.meals-chosen span').text()) + 1);
        // }
    }

    function updateQty(modifer, thisObj) {
        var mealsChosen = parseInt($('.meals-chosen span').text());
        fieldName = thisObj.attr('field');
        var currentVal = parseInt($('input[data-attr=' + fieldName + ']').val());

        if (modifer == 'plus') {
            $('input[data-attr=' + fieldName + ']').val(currentVal + 1);
            $('.meals-chosen span').text(mealsChosen + 1);
        } else {
            if(currentVal > 0) { 
                $('input[data-attr=' + fieldName + ']').val(currentVal - 1);
                $('.meals-chosen span').text(mealsChosen - 1);
            }
        }
        allowNext();
    }

    function updateQtyModal(modifer, thisObj) {
        fieldName = thisObj.attr('field');
        var currentModalVal = parseInt($('input[data-attr=' + fieldName + ']').val());
        if (modifer == 'plus') {
            $('input[data-attr=' + fieldName + ']').val(currentModalVal + 1);
        } else {
            $('input[data-attr=' + fieldName + ']').val(currentModalVal - 1);
        }
    }

    function hasAllBeenChecked() {
        let current_slide = slider.slick('slickCurrentSlide');
        let current_slide_questions = $('.slick-slide[data-slick-index="' + current_slide + '"] .row:visible').length;
        let current_answered = 0
        $('.slick-slide[data-slick-index="' + current_slide + '"] .row:visible').each(function(){
            $(this).find('.bordered-box').each(function(){
                if ($(this).hasClass('is-selected')) {
                    current_answered = current_answered + 1;
                }
            });
        });
        if (current_slide_questions == current_answered) {
            return true;
        } else {
            return false;
        }
    }

    function subscriptionCheckout(callback) {
        var subscription_data = {
            "charge_interval_frequency": "1",
            "shipping_interval_frequency": "1",
            "shipping_interval_unit_type": "week"
        }
        $('.subscription-meals').each(function (index) {
            balancedId = parseFloat($(this).attr('data-variant-id-balanced'));
            let balancedSellingId = parseFloat($(this).attr('data-variant-selling-balanced'));
            slimId = parseFloat($(this).attr('data-variant-id-slim'));
            let slimSellingId = parseFloat($(this).attr('data-variant-selling-slim'));
            standardId = parseFloat($(this).attr('data-variant-id-standard'));
            let standardSellingId = parseFloat($(this).attr('data-variant-selling-standard'));

            
            // if (selectedType == 'slim') {
            //     var thisProductID = parseFloat($(this).attr('data-variant-id-slim'));
            // } else {
            //     var thisProductID = parseFloat($(this).attr('data-variant-id-balanced'));
            // }
            var slimInputValue = parseFloat($(this).find('.slim-quantity-box').val());
            var balancedInputValue = parseFloat($(this).find('.balanced-quantity-box').val());
            var standardInputValue = parseFloat($(this).find('.standard-quantity-box').val());
            if (standardInputValue > 0) {
                push_to_queue(standardId, standardInputValue, subscription_data , standardSellingId);
            }
            if (slimInputValue > 0) {
                push_to_queue(slimId, slimInputValue, subscription_data , slimSellingId);
            }
            if (balancedInputValue > 0) {
                push_to_queue(balancedId, balancedInputValue, subscription_data , balancedSellingId);
            }
            var isLastElement = index == $('.subscription-meals').length -1;
            if (isLastElement) {
                callback();
               // window.location = '/cart'
            }
        })                    
    }

    function singleCheckout() {
        if ($('#snack-modal').length && !$('#snack-modal').is(":visible")) {
            var snackPopup = new bootstrap.Modal(document.getElementById('snack-modal'));
            snackPopup.show();
        } else {
            getMeals(function(){
                Shopify.moveAlong();
            });
        }
    }

    $('#no-snack-button').click(function() {
        if (selectedItems.type == 'subscription') {
            subscriptionCheckout(function(){
                Shopify.moveAlong();
            })
        } else {
            getMeals(function(){
                Shopify.moveAlong();
            });
        }
    });

    $('.goal').on('click', function(){
        var thisAttr = $(this).data('attr');
        $('.one-off-meals').each(function(){
            var itemPrice = $(this).data('price-' + thisAttr);
            $(this).find('.product-price--price').text(itemPrice)
        });
        storeSelected('#selectedGoal', $(this), 'attr');
    });

    $('.meals-per-week').on('click', function(){
        storeSelected('#selectedMeals', $(this), 'attr');
        if ($('#selectedType').text() == 'subscription') {
            $('#toggleMealPlan').addClass('active');
        } else if ($('#selectedType').text() == 'single') {
            $('#toggleMealPlan').removeClass('active');
        }

        if ($(this).data('attr') == "custom") {
            $('.custom-amount').slideDown(function(){
                $('#selectedMeals').text($('.custom-amount input').val())
                slider.slick('setPosition'); 
            });
        } else {
            $('.custom-amount').slideUp(function () {
                slider.slick('setPosition');
            });

            $('.meals-left span').text($(this).data('attr'));
        }
    });

    $('.snack-model').on('click', function(){
        var snackId = $(this).data('variant-id');
        var snackQty = parseFloat($(this).closest('.modal-body').find('.quantity-box').val());
        push_to_queue(snackId, snackQty);

        if (selectedItems.type == 'subscription') {
            subscriptionCheckout(function(){
                Shopify.moveAlong();
            })
        } else {
            getMeals(function(){
                Shopify.moveAlong();
            });
        }
    })

    $('.custom-amount input').change(function(){
        var selectCustom = $(this).val()

        $('.meals-left span').text(selectCustom);
        $('#selectedMeals').text(selectCustom);
    });

    $('.delivery_collection').on('click', function(){
        if ($(this).data('attr') == "subscription") {
            selectedItems.type = 'subscription';        
            $('#funnel-next').attr('data-modifer', 'skip');
            $('#funnel-next').on('click', function(){
                $('#funnel-next').attr('data-modifer', 'subscription-checkout');
            });
        } else {
            selectedItems.method = 'single'; 
            $('#funnel-next').attr('data-modifer', '');
            $('#funnel-next').on('click', function(){
                $('#funnel-next').attr('data-modifer', 'single-checkout');
            });
        }
    });

    let accepted_postcodes = "bd21, bd23, ls29, ls21, ls20, ls19, bb18, bd1, bd2, bd3, bd4, bd5, bd6, bd7, bd8, bd9, bd10, bd11, bd12, bd13, bd14, bd15, bd16, bd17, bd18, bd20, bd22, bd97, bd98, bd99".split(', ');
    let exception_postcodes = "bd235, bd234".split(', ');
    $('#postcode-check-form').submit(function(event){
        event.preventDefault();
        function isValidPostcode(p) { 
            var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i; 
            return postcodeRegEx.test(p); 
        }
        function formatPostcode(p) { 
            if (isValidPostcode(p)) { 
                var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i; 
                return p.replace(postcodeRegEx,"$1 $2"); 
            } else {
                return p;
            }
        }

        function checkInput(input, words) {
            return words.some(word => input.toLowerCase().includes(word.toLowerCase()));
        }

        let postcode_check = $(this).find('input[name="postcode-check"]').val().toLowerCase(),
            postcode_format = formatPostcode(postcode_check),
            postcode_area = postcode_format.split(' ')[0];
        if (accepted_postcodes.indexOf(postcode_area) > -1 && checkInput(postcode_check, exception_postcodes) == false) {
            $('#postcode-check-alert').removeClass('alert-danger').addClass('alert-success').text($('#postcode-check-alert').data('success'));
            allowNext();
        } else {
            $('#postcode-check-alert').removeClass('alert-success').addClass('alert-danger').text($('#postcode-check-alert').data('fail'));
            $('#funnel-next').addClass('disabled');
        }
        $('#postcode-check-alert').show();
    });

    // Change plan type
    $('.plan-type').click(function () {
        storeSelected('#selectedType', $(this), 'attr');
        var checkedCheck = hasAllBeenChecked();
        
        // Subscription based checkout 
        if ($('#selectedType').text() == 'subscription') {
            $('.preference-container').show();
            slider.slick('setPosition');
            $('#funnel-next').attr('data-modifer', 'subscription-checkout');
        } else if ($('#selectedType').text() == 'single') {
            $('.preference-container').hide();
            slider.slick('setPosition'); 
        }
    });

    // Change plan preferencee
    $('.plan-preference').click(function () {
        storeSelected('#selectedPreference', $(this), 'attr');

        $('.product-grid-item').each(function () {
            $(this).show();
        });
    });

    $('.qtyplus:not(.qtyplusModal)').click(function (e) {
        e.preventDefault();
        alterBarValues('plus');
        var price = parseFloat($(this).data('price')).toFixed(2);
        var nowVal = $('.total-amount-input').val();
        plusPrice = Number(nowVal) + Number(price);
        $('.total-amount-input').val(plusPrice.toFixed(2));
        updateQty('plus', $(this));
    });

    $(".qtyminus:not(.qtyminusModal)").click(function (e) {
        e.preventDefault();
        alterBarValues();
        var price = parseFloat($(this).data('price')).toFixed(2);
        var nowVal = $('.total-amount-input').val();
        var quantBox = $(this).parent().find('.quantity-box').val();
        if(nowVal > 0 && quantBox > 0) {
            plusPrice = Number(nowVal) - Number(price);
            $('.total-amount-input').val(plusPrice.toFixed(2));
        }
        updateQty('minus', $(this));
    });

    $('.qtyplusModal').click(function (e) {
        e.preventDefault();
        updateQtyModal('plus', $(this));
    });

    $(".qtyminusModal").click(function (e) {
        e.preventDefault();
        updateQtyModal('minus', $(this));
    });

    $('.bordered-box:not(.meal-box)').click(function(){
        $(this).addClass('is-selected');
        $(this).closest('.row').find('.bordered-box').not($(this)).removeClass('is-selected');
        var checkedCheck = hasAllBeenChecked();
        if (checkedCheck == true) {
            allowNext();
        }
    });

    $('#funnel-next').on('click', function(){
        setTimeout(() => {
            slider.slick('setPosition'); 
        }, 600);
        $.fn.isInViewport = function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementTop < viewportBottom;
        };

        // Skip Slide
        function nextSlide(modifier) {
            if (modifier == 'skip') {
                slideIndex = slider.slick('slickCurrentSlide') + 2;
                slider.slick('slickGoTo', slideIndex);
            } else {
                slider.slick('slickNext');
            }
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.tabbable').offset().top
            }, 300);
        }

        // Checkout
        const modifier = $('#funnel-next')[0].dataset.modifer;
        if (modifier == 'single-checkout') {
            singleCheckout();
        } else if (modifier == 'subscription-checkout') {
            // if ($('#snack-modal').length && !$('#snack-modal').is(":visible")) {
            //     var snackPopup = new bootstrap.Modal(document.getElementById('snack-modal'));
            //     snackPopup.show();

            // } else {
                subscriptionCheckout(function(){
                    Shopify.moveAlong();
                });
            //}
        } else if (modifier == 'skip') {
            nextSlide(modifier);
        } else {
            nextSlide();
        }
    
        $(this).attr('data-modifer', "");
        if (hasAllBeenChecked() == false) {
            // $(this).addClass('disabled');
        }
    });


    $('#funnel-prev').on('click', function(){
        slider.slick('slickPrev');
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.tabbable').offset().top
        }, 300);
        if (hasAllBeenChecked()) {
            $('#funnel-next').removeClass('disabled');
        }
    });

    slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        if (currentSlide >= 2) {
            $('.nmbr-2').addClass('active')
            $('.line-2').addClass('active')
        }  
        
        if (currentSlide >= 4) {
            $('.nmbr-3').addClass('active')
            $('.line-3').addClass('active')
        }

        if (currentSlide == 2) {
            $('.brown-bar-progress').addClass('active')
        } else {
            $('.brown-bar-progress').removeClass('active')
        }

        if (currentSlide == 2 || currentSlide == 0) {
            $('#funnel-prev').addClass('disabled')
        } else {
            $('#funnel-prev').removeClass('disabled')
        }
    }); 
});